module.exports = __webpack_public_path__ + "img/exam_jan_2025_j6yy5a2k.028d739f.jpg";